import dayjs from 'dayjs'
// import { }

function ColorFunc() {
  // const Colors = ['#E2651A', '#418F1F', '#9348F3', '#3d84a8', '#1a237e', '#08d9d6', '#e84a5f', '#4a266a']
  const Colors = ['#418F1F', '#9348F3', '#1F69E0', '#E99D00', '#6C5AFB', '#7B9900', '#C343E0', '#E2651A', '#009BB0', '#DD3332']
  let i = 0
  const colorMap = {}
  return (name) => {
    let color = colorMap[name]
    if (!color) {
      color = Colors[i % Colors.length]
      colorMap[name] = color
      if (i >= Colors.length - 1) {
        i = 0
      } else {
        i++
      }
    }
    return color
  }
}

export const generateColor = ColorFunc()

export function getTimeLabel(timestamp) {
  const t = new Date(0, 0, 0, 0, 0, timestamp / 1000)
  let hour = t.getHours()
  let minute = t.getMinutes()
  let second = t.getSeconds()
  const originHour = hour
  if (hour < 10) hour = `0${hour}`
  if (minute < 10) minute = `0${minute}`
  if (second < 10) second = `0${second}`
  return originHour > 0 ? `${hour}:${minute}:${second}` : `${minute}:${second}`
}

export function havePrivilege(privilege) {
  const currentTime = dayjs().unix()
  const { value, consumed, expire_time, trial, effect_time } = privilege || {}
  return (value - consumed > 0 && currentTime < expire_time && currentTime >= effect_time) || !!trial
}

export function haveTrial(privilege) {
  const currentTime = dayjs().unix()
  const { value, consumed, expire_time, trial, effect_time } = privilege || {}
  return !(value - consumed > 0 && currentTime < expire_time && currentTime >= effect_time) && (!!trial)
}

export function formatTranscript(transcript) {
  const { end, start } = transcript
  const duration = Math.floor((end - start) / 1000)
  return {
    ...transcript,
    offset: Math.floor(start / 1000),
    duration,
  }
}

export function transformSpeakers(transcripts, speakers) {
  for (let i = 0; i < transcripts.length; i++) {
    const item = transcripts[i]
    const name = item.speaker
    const isMeetingRoom = name.includes('#发言人')
    const displayName = isMeetingRoom ? name.split('#')[1] : name
    const roomName = isMeetingRoom ? name.split('#')[0] : ''
    item.color = generateColor(item.speaker)
    item.startLabel = getTimeLabel(item.start)
    item.name = displayName
    item.index = i
    item.avatar = speakers[item.unique_id]?.avatar
    item.startSecond = Math.floor(item.start / 1000)
    item.roomName = roomName
    item.isMeetingRoom = isMeetingRoom
    item.speakerId = item.speaker_id
  }
  return transcripts
}

export function groupBySpeaker(transcripts) {
  const speakerKey = 'speaker_id'
  const speakerKeys = []
  const group = transcripts.reduce((acc, cur) => {
    const _cur = formatTranscript(cur)
    if (acc[cur[speakerKey]]) {
      const last = acc[cur[speakerKey]][acc[cur[speakerKey]].length - 1]
      // 间隔不超过20s合并
      if (_cur.start - last.end > 20 * 1000) {
        acc[cur[speakerKey]].push(_cur)
      } else {
        last.end = _cur.end
        last.duration = (last.end - last.start) / 1000
      }
    } else {
      acc[cur[speakerKey]] = [_cur]
      speakerKeys.push(cur[speakerKey])
    }
    return acc
  }, {})
  return speakerKeys.map(speakerKey => {
    const firstTranscript = group[speakerKey][0]
    return {
      speaker: firstTranscript.speaker,
      speakerLine: group[speakerKey],
      name: firstTranscript.name,
      color: firstTranscript.color,
      avatar: firstTranscript.avatar,
      isMeetingRoom: firstTranscript.isMeetingRoom,
      roomName: firstTranscript.roomName,
      uniqueId: firstTranscript.unique_id,
      role: firstTranscript.role,
      speakerId: speakerKey
    }
  })
}

export function caculateSpeakingTime(transcripts) {
  const speakingTime = {}
  let totalSpeakingTime = 0
  transcripts.forEach(transcript => {
    const { speaker, start, end } = transcript
    const duration = end - start
    if (speakingTime[speaker]) {
      speakingTime[speaker].duration += duration
    } else {
      speakingTime[speaker] = { duration, percent: 0 }
    }
    totalSpeakingTime += duration
  })
  Object.keys(speakingTime).forEach(speaker => {
    const precent = (speakingTime[speaker].duration / totalSpeakingTime) * 100
    speakingTime[speaker].percent = precent.toFixed(2) + '%'
  })
  return {
    speakingTime,
    totalSpeakingTime
  }
}

// 数字转中文，比如 12 => 十二
export function numberToChinese(num) {
  const units = ['', '十', '百', '千', '万', '亿']
  const chars = '零一二三四五六七八九'

  // 处理 0
  if (num === 0) {
    return chars[0]
  }

  // 将数字转换为字符串，反转便于处理单位
  const numStr = num.toString().split('').reverse()
  let result = ''
  let zeroFlag = false

  for (let i = 0; i < numStr.length; i++) {
    const digit = numStr[i]
    if (digit === '0') {
      if (!zeroFlag) {
        result = chars[0] + result
        zeroFlag = true
      }
    } else {
      zeroFlag = false
      result = chars[digit] + units[i] + result
    }
  }
  // 去掉结果中可能的前导零和多余的"一十"
  result = result.replace(/零+/g, '零').replace(/零$/, '')
  if (result.startsWith('一十')) {
    result = result.slice(1)
  }
  return result
}